<template>
  <v-select
    v-if="selectLists"
    v-bind="$attrs"
    v-model="input"
    :items="selectLists.ServiceRoutes"
    item-text="Text"
    item-value="Value"
    :label="label"
    dense
  >
    <template v-slot:item="{ item }">
      <v-icon small :color="extraData(item, 'Color')">{{
        serviceRouteIcon
      }}</v-icon>
      <div class="ml-1">{{ item.Text }}</div>
    </template>
    <template v-slot:selection="{ item }">
      <v-icon small :color="extraData(item, 'Color')">{{
        serviceRouteIcon
      }}</v-icon>
      <div class="ml-1">
        {{ item.Text }}
      </div>
    </template>
  </v-select>
</template>

<script>
import { ref, watch } from 'vue'
import { selectListCache } from '@/services/SelectListCache'
import { feature } from '@/use/Constants'
export default {
  name: 'ServiceRoutePicker',
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Route'
    }
  },
  setup(props, context) {
    const input = ref()
    const selectLists = ref()
    const serviceRouteIcon = ref()

    watch(
      () => props.value,
      newVal => {
        input.value = newVal
      }
    )

    watch(
      () => input.value,
      newVal => {
        context.emit('input', newVal)
        context.emit('change', newVal)
      }
    )

    const loadSelectLists = async () => {
      const selectListNames = [selectListCache.name.ServiceRoutes]

      selectLists.value = await selectListCache.get(selectListNames)
    }

    const extraData = (item, dataName) => {
      return JSON.parse(item.ExtraData)[dataName]
    }

    const initControl = async () => {
      serviceRouteIcon.value = feature.routes.icon
      input.value = props.value
      await loadSelectLists()
    }

    initControl()
    return { input, selectLists, extraData, serviceRouteIcon }
  }
}
</script>

<style lang="scss" scoped></style>
